export default function() {
  let resultHeight =
    document.documentElement.clientHeight -
    document.getElementsByClassName("result-table")[0].offsetTop -
    64;
  return resultHeight;
}
